function SegmentFormController($uibModal) {
  const ctrl = this;

  ctrl.$onInit = () => {
    ctrl.segmentsFull = checkTypes();
  };

  ctrl.$onChanges = changes => {
    if (changes.currentSegments && ctrl.currentSegments && ctrl.currentSegments.length === 0) {
      ctrl.segmentsFull = checkTypes();  
    }
  };

  ctrl.removeSegment = index => {
    ctrl.currentSegments.splice(index, 1);
    ctrl.segmentsFull = checkTypes();
    ctrl.onEdit({
      $event: {
        segments: ctrl.currentSegments,
      },
    });
  };

  const checkTypes = () => {
    if (!ctrl.currentSegments) return;
    if (ctrl.currentSegments.length === 2) {
      return true;
    } else {
      return false;
    }
  };

  ctrl.openSegmentModal = () => {
    // Check what types of segments is already added
    if (ctrl.currentSegments.length > 0) {
      _.each(ctrl.currentSegments, segment => {
        if (segment.stream_type === 'TEXT') {
          ctrl.filteredSegments = ctrl.segments.filter(p => p.stream_type === 'AUDIO');
        } else if (segment.stream_type === 'AUDIO') {
          ctrl.filteredSegments = ctrl.segments.filter(p => p.stream_type === 'TEXT');
        } else {
          ctrl.filteredSegments = ctrl.segments;
        }
      });
    } else {
      ctrl.filteredSegments = ctrl.segments;
    }

    let modalInstance = $uibModal.open({
      component: 'segmentModal',
      backdrop: 'static',
      windowClass: 'subSystemWindow',
      resolve: {
        segments: () => ctrl.filteredSegments,
      },
    });

    modalInstance.result.then(
      selectedSegment => {
        // User pressed 'Yes' in the modal.
        ctrl.currentSegments.push(selectedSegment);
        ctrl.segmentsFull = checkTypes();
        ctrl.onEdit({
          $event: {
            segments: ctrl.currentSegments,
          },
        });
      },
      () => {
        // User pressed 'Cancel' in the modal, do nothing.
      }
    );
  };

  ctrl.openCreateSegmentModal = () => {
    ctrl.restrictType = null;
    // Check what types of segments is already added
    if (ctrl.currentSegments.length > 0) {
      _.each(ctrl.currentSegments, segment => {
        if (segment.stream_type === 'TEXT') {
          ctrl.restrictType = 'TEXT';
        } else if (segment.stream_type === 'AUDIO') {
          ctrl.restrictType = 'AUDIO';
        }
      });
    }

    let modalInstance = $uibModal.open({
      component: 'createSegmentModal',
      backdrop: 'static',
      windowClass: 'subSystemWindow',
      resolve: {
        restrictType: () => ctrl.restrictType
      },
    });

    modalInstance.result.then(
      createdSegment => {
        // User pressed 'Yes' in the modal.
        ctrl.currentSegments.push(createdSegment);
        ctrl.segmentsFull = checkTypes();
        ctrl.onEdit({
          $event: {
            segments: ctrl.currentSegments,
          },
        });
      },
      () => {
        // User pressed 'Cancel' in the modal, do nothing.
      }
    );
  };
}

angular
  .module('pis-common.module')
  .controller('SegmentFormController', SegmentFormController);
